import React, { useState, useRef, useEffect } from 'react';

import Field from '../components/Field';
import Ball from '../components/Ball';
import Player from '../components/Player';
import Shadow from '../components/Shadow';
import TextBox, { TextBoxInput } from '../components/TextBox';
import NewsSignupForm from '../components/NewsSignupForm';
import SettingsView, { DEFAULT_SETTINGS } from '../components/Settings';
import { CircleFader } from '../components/Effects';
import VisualDebug from '../components/VisualDebug';
import FileManager from '../components/FileManager';

import { tryVibrate } from '../utils/vibrate';

import { convertSVGToPNG } from '../export';
import { shareImageDataURL, dataURItoBlob, shareImageBlob } from '../share';

import {vec_normalize, vec_perpendicular, vec_add, vec_scale, vec_sub, vec_negate, vec_length, vec_dot} from '../math';
import { pathDataFromStroke, arrowDataFromStroke, isScribble, calculateEvenPoints } from '../strokes';

import { SettingsProvider } from '../context/useSettingsContext';
import { SvgProvider } from '../context/useSvgContext';

import Select, { SelectChangeEvent } from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import SettingsIcon from '@mui/icons-material/Settings';
import DownloadIcon from '@mui/icons-material/Download';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import useUndoRedo from '../hooks/useUndoRedo';
import useFiles from '../hooks/useFiles';
import LocalFileManager from '../utils/LocalFileManager';

import './SoccerBoard.css';

const range = n => [...Array(n).keys()];

const isIpad = /iPad/i.test(navigator.userAgent);

const roster = {
  1: 'Becker',
  2: 'Kaden',
  3: 'Kyra',
  4: 'Mia',
  //5: 'Thomas',
  6: 'Matthew',
  7: 'Lauren',
  8: 'Salah',
  9: 'Diaz',
  10: 'Gakpo',
  11: 'Mac Allister',
};

const localFileManager = LocalFileManager();
window.foo = localFileManager;

const createNewBoard = () => {
  // 11v11 with home on field
  //return {"view":{"x":0,"y":0,"theta":0,"scale":1},"field":{"width":70,"length":110,"numPlayers":11},"players":[{"team":"away","jersey":10,"x":8.804572105407715,"y":-17.993603706359863},{"team":"away","jersey":2,"x":-25.545955657958984,"y":-25.899279594421387},{"team":"away","jersey":3,"x":27.035972595214844,"y":-27.366107940673828},{"team":"away","jersey":5,"x":6.356512069702148,"y":-37.054359436035156},{"team":"away","jersey":4,"x":-7.464432001113892,"y":-36.83453178405762},{"team":"away","jersey":6,"x":0.9528430700302124,"y":-28.02558135986328},{"team":"away","jersey":8,"x":-9.231015682220459,"y":-21.39887809753418},{"team":"away","jersey":11,"x":29.218225479125977,"y":-4.600321292877197},{"team":"away","jersey":9,"x":0.12150073051452637,"y":-11.538766860961914},{"team":"away","jersey":7,"x":-29.28697395324707,"y":-4.760191440582275},{"team":"away","jersey":1,"x":0.017591692507267,"y":-49.684250831604004},{"team":"home","jersey":9,"x":-0.3599963378906183,"y":3.479985351562499},{"team":"home","jersey":3,"x":-24.839996337890586,"y":31.800007324218754},{"team":"home","jersey":2,"x":24.119992675781244,"y":32.07998168945313},{"team":"home","jersey":6,"x":-3.2399963378906187,"y":26.880003662109395},{"team":"home","jersey":11,"x":-30.240007324218748,"y":3.520000000000005},{"team":"home","jersey":10,"x":-12.239996337890624,"y":13.999999999999998},{"team":"home","jersey":8,"x":6.959996337890638,"y":16.360003662109374},{"team":"home","jersey":7,"x":30.359996337890646,"y":2.600000000000005},{"team":"home","jersey":5,"x":-10.319992675781238,"y":40.84001098632812},{"team":"home","jersey":4,"x":8.400007324218747,"y":41.00000366210936},{"team":"home","jersey":1,"x":-0.11999999999999067,"y":49.760003662109355}],"ball":{"x":0,"y":0},"objects":[],"strokes":[]};
  //return {"view":{"x":0,"y":0,"theta":0,"scale":1},"field":{"width":70,"length":110,"numPlayers":11},"players":[{"team":"home","jersey":9,"x":-0.3599963378906183,"y":3.479985351562499},{"team":"home","jersey":3,"x":-24.839996337890586,"y":31.800007324218754},{"team":"home","jersey":2,"x":24.119992675781244,"y":32.07998168945313},{"team":"home","jersey":6,"x":-3.2399963378906187,"y":26.880003662109395},{"team":"home","jersey":11,"x":-30.240007324218748,"y":3.520000000000005},{"team":"home","jersey":10,"x":-12.239996337890624,"y":13.999999999999998},{"team":"home","jersey":8,"x":6.959996337890638,"y":16.360003662109374},{"team":"home","jersey":7,"x":30.359996337890646,"y":2.600000000000005},{"team":"home","jersey":5,"x":-10.319992675781238,"y":40.84001098632812},{"team":"home","jersey":4,"x":8.400007324218747,"y":41.00000366210936},{"team":"home","jersey":1,"x":-0.11999999999999067,"y":49.760003662109355},{"team":"away","jersey":1,"x":42,"y":-5},{"team":"away","jersey":2,"x":42,"y":-10},{"team":"away","jersey":3,"x":42,"y":-15},{"team":"away","jersey":4,"x":42,"y":-20},{"team":"away","jersey":5,"x":42,"y":-25},{"team":"away","jersey":6,"x":42,"y":-30},{"team":"away","jersey":7,"x":42,"y":-35},{"team":"away","jersey":8,"x":42,"y":-40},{"team":"away","jersey":9,"x":42,"y":-45},{"team":"away","jersey":10,"x":42,"y":-50},{"team":"away","jersey":11,"x":42,"y":-55}],"ball":{"x":0,"y":0},"objects":[], "strokes": []};

  // 11v11 with home and away on field for kickoff..
  //return {"view":{"x":0,"y":0,"theta":0,"scale":1},"field":{"width":70,"length":110,"numPlayers":11},"players":[{"team":"away","jersey":9,"x":0.11999633789062197,"y":-11.63999816894531},{"team":"away","jersey":3,"x":23.280000000000012,"y":-27.72000366210938},{"team":"away","jersey":2,"x":-25.199996337890628,"y":-26.440001831054666},{"team":"away","jersey":11,"x":17.400007324218766,"y":-2.919998168945311},{"team":"away","jersey":7,"x":-16.56000732421874,"y":-2.5999999999999868},{"team":"away","jersey":10,"x":7.319996337890637,"y":-16.51999725341797},{"team":"away","jersey":8,"x":-6.359992675781248,"y":-18.40000000000001},{"team":"away","jersey":6,"x":0.6000000000000006,"y":-28.67999816894531},{"team":"away","jersey":5,"x":7.559992675781254,"y":-36.75999633789062},{"team":"away","jersey":4,"x":-7.800003662109376,"y":-36.2},{"team":"away","jersey":1,"x":-0.00000732421874860556,"y":-51.67999908447266},{"team":"home","jersey":9,"x":-0.3599963378906183,"y":3.479985351562499},{"team":"home","jersey":3,"x":-24.839996337890586,"y":31.800007324218754},{"team":"home","jersey":2,"x":24.119992675781244,"y":32.07998168945313},{"team":"home","jersey":6,"x":-3.2399963378906187,"y":26.880003662109395},{"team":"home","jersey":11,"x":-30.240007324218748,"y":3.520000000000005},{"team":"home","jersey":10,"x":-12.239996337890624,"y":13.999999999999998},{"team":"home","jersey":8,"x":6.959996337890638,"y":16.360003662109374},{"team":"home","jersey":7,"x":30.359996337890646,"y":2.600000000000005},{"team":"home","jersey":5,"x":-10.319992675781238,"y":40.84001098632812},{"team":"home","jersey":4,"x":8.400007324218747,"y":41.00000366210936},{"team":"home","jersey":1,"x":-0.11999999999999067,"y":49.760003662109355}],"ball":{"x":0,"y":0},"objects":[]};

  // default start point below..
  const w = 70;
  const l = 110;
  const numPlayers = 11;

  // const playersHome = range(numPlayers).map(i => ({ team: 'home', jersey: i+1, x: w/2 + 7, y: 5 + 5*i }));
  // const playersAway = range(numPlayers).map(i => ({ team: 'away', jersey: i+1, x: w/2 + 7, y: -5 + -5*i }));
  const playersHome = range(numPlayers).map(i => ({ team: 'home', jersey: i+1, x: -w/2 + 5*i, y: l/2 + 7 }));
  const playersAway = range(numPlayers).map(i => ({ team: 'away', jersey: i+1, x: -w/2 + 5*i, y: -l/2 - 7 }));

  const result = {
    view: {
      x: 0,
      y: 0,
      theta: 0,
      scale: 1,
    },
    field: {
      width: w,
      length: l,
      numPlayers,
    },
    players: playersHome.concat(playersAway),
    ball: { x: 0, y: 0 },
    objects: [],
    strokes: [],
    text: [],
  };
  result.players = result.players.map(p => {
    if (p.jersey === 1) {
      //"x":-0.24780531972646713,"y":50.60348892211914
      p.x = 0;
      p.y = p.team === 'home' ? 50.60348892211914 : -50.60348892211914;
      return p;
    } else {
      return p;
    }
  });
  return result;
};

const loadSettings = () => {
  try {
    const settingsAsString = localStorage.getItem('settings');
    return JSON.parse(settingsAsString);
  } catch(e) {
    console.error('Unable to load settings');
    return DEFAULT_SETTINGS;
  }
}

// https://www.telerik.com/blogs/how-to-use-svg-react
const SoccerBoard = () => {
  const Files = useFiles(localFileManager);

  const [debugMessage, setDebugMessage] = useState(null);

  //const [data, setData] = useState(initialData);
  const [currentBoardId, setCurrentBoardId] = useState();
  const { data, setData, setDataNoUndo, undo, redo, canUndo, canRedo } = useUndoRedo();

  const [settings, setSettings] = useState({...loadSettings(), vdebug: setDebugMessage});
  const [showSettings, setShowSettings] = useState(false);

  const [showShadows, setShowShadows] = useState(false);
  const [drawMode, setDrawMode] = useState(false);
  const svgRef = useRef();
  const svgContainerRef = useRef();
  const fieldDivRef = useRef();

  const [currentStroke, setCurrentStroke] = useState(null);
  const [strokeStyle, setStrokeStyle] = useState('Move');

  const [pixelData, setPixelData] = useState({pixelWidth:1, minTouchSize: 1});

  const [lastTeamMoved, setLastTeamMoved] = useState('home');

  const [guiLocation, setGuiLocation] = useState('bottom');

  const [textEditIndex, setTextEditIndex] = useState(null);

  const [addMenuEl, setAddMenuEl] = useState(null);

  const [circleEffect, setCircleEffect] = useState(null);

  useEffect(() => {
    // hack for moment.. to save new data/state to local "file system"
    console.log('%%% data changed', currentBoardId, data);
    if (currentBoardId) {
      localFileManager.update(currentBoardId, data);
    }
  }, [data]);

  // 0.2, 40
  const scaleMax = 40;
  const scaleMin = 0.2;

  const switchToBoard = (board) => {
    setCurrentBoardId(board?.boardId);
    setDataNoUndo(board?.data);
  }

  // on startup
  useEffect(() => {
    const boards = localFileManager.list();
    switchToBoard(boards.length > 0 ? boards[0] : null);
  }, []);

  const updatePixelWidth = () => {
    // todo - can this be calculated straight from the matrix?
    const a = pixel2svg(0, 0);
    const b = pixel2svg(1, 0);
    const length = vec_length(vec_sub([a.x, a.y], [b.x, b.y]));

    const PLAYER_RADIUS = 8.66 / 12 / 3;
    const MIN_PLAYER_RADIUS_PIXELS = 30;
    const minTouchSize = Math.min(MIN_PLAYER_RADIUS_PIXELS * length, PLAYER_RADIUS * 10);

    setPixelData({pixelWidth: length, minTouchSize});
  }
  useEffect(updatePixelWidth, [svgRef]);

  const getId = (team, p) => `${team}_${p.jersey}`;

  const updatePlayerName = (team, jersey, name) => {
    if (team === 'home') {
      roster[jersey] = name;
    }
    // setData(state => {
    //   state.players = state.players.map(p => {
    //     if (p.team === team && p.jersey === jersey) {
    //       return { ...p, name };
    //     } else {
    //       return p;
    //     }
    //   });
    //   return state;
    // });
  }

  const moveState = {};
  const movePlayer = (stage, team, jersey, x, y, didClickEdit=false) => {
    //console.log(stage,team, jersey, x, y);
    setLastTeamMoved(team);
    if (stage === 'down') {
      setData(prev => {
        // move clicked player to first in list so it will be drawn on top
        const index = prev.players.findIndex(e => e.team === team && e.jersey === jersey);
        const newData = {...prev};
        if (team && jersey) {
          newData.players = newData.players.map((x, i) => {
            if (i === 0) {
              return {...(newData.players[index])};
            } else if (i === index) {
              return {...(newData.players[0])};
            } else {
              return x;
            }
          });
        }
        return newData;
      });
      moveState.start = { time: new Date(), x, y};
    } else if (stage === 'move') {
      const a = pixel2svg(x, y);
      const b = pixel2svg(moveState.lastX, moveState.lastY);
      const dx = a.x - b.x;
      const dy = a.y - b.y;

      setDataNoUndo(prev => {
        const newData = {...prev};
        newData.players = newData.players.map((item, i) => {
          if (i===0 && team && jersey) {
            return {
              ...item,
              x: item.x + dx,
              y: item.y + dy
            };
          } else if (jersey === null && item.team === team && item.jersey !== 1 && isOnField(item)) { // don't move goalie
            return {
              ...item,
              x: item.x + dx,
              y: item.y + dy
            };
          } else {
            return item;
          }
        });
        return newData;
      });
    } else if (stage === 'up') {
      const now = new Date();
      const elapsed = now - moveState.start.time;
      console.log('elapsed', elapsed);
      if (elapsed < 100) {
        if (didClickEdit) {
          const name = prompt('Enter name');  // todo - replace with AutoComplete mui component
          if (name !== null) {
            updatePlayerName(team, jersey, name);
          }
        } else {
          const index = data.players.findIndex(e => (e.team === team && e.jersey === jersey));
          if (index >= 0) {
            animateBallTo(data.players[index].x, data.players[index].y);
          }
        }
      }
    }
    moveState.lastX = x;
    moveState.lastY = y;
  }

  const moveText = (stage, index, x, y) => {
    if (stage === 'down') {
      moveState.start = { time: new Date(), x, y};
    } else if (stage === 'move') {
      const a = pixel2svg(x, y);
      const b = pixel2svg(moveState.lastX, moveState.lastY);
      const dx = a.x - b.x;
      const dy = a.y - b.y;

      setDataNoUndo(prev => {
        const newData = {...prev};
        newData.text = newData.text.map((item, i) => {
          if (i===index) {
            return {
              ...item,
              x: item.x + dx,
              y: item.y + dy
            };
          } else {
            return item;
          }
        });
        return newData;
      });
    } else if (stage === 'up') {
    }
    moveState.lastX = x;
    moveState.lastY = y;
  }

  const getClosestPlayer = (x, y) => {
    const results = (
      data.players
      .map((player, index) => ({ player, index, distance: vec_length(vec_sub([x, y], [player.x, player.y])) }))
      .sort((a, b) => a.distance - b.distance)
    );
    return results.at(0);
  }
  const moveBallData = {};
  const moveBall = (stage, x, y) => {
    const newData = {...data};
    if (stage === 'down') {
      const pos = pixel2svg(x, y);
      const closest = getClosestPlayer(data.ball.x, data.ball.y);
      if (closest.distance < 0.5) {
        moveBallData.closest = closest.index;
        moveBallData.numMoves = 0;
        moveBallData.moveDist = 0;
        moveBallData.timerId = setTimeout(() => {
          settings.vdebug(`moveBallData.moveDist = ${moveBallData.moveDist}`);
          if (moveBallData.moveDist < 2) {
            moveBallData.closest = null;
            setCircleEffect({x: data.ball.x, y: data.ball.y});
            tryVibrate();
          }
          moveBallData.timerId = null;
        }, 1000);
      } else {
        moveBallData.closest = null;
      }
    } else if (stage === 'move') {
      const a = pixel2svg(x, y);
      const b = pixel2svg(moveBallData.lastX, moveBallData.lastY);
      const dx = a.x - b.x;
      const dy = a.y - b.y;

      newData.ball.x += dx;
      newData.ball.y += dy;

      if (moveBallData.closest !== null) {
        newData.players[moveBallData.closest].x += dx;
        newData.players[moveBallData.closest].y += dy;
      }

      setData(newData);

      moveBallData.moveDist += Math.sqrt(dx*dx + dy*dy);
      moveBallData.numMoves++;
    } else if (stage === 'up') {
      moveBallData.closest = null;
    }
    moveBallData.lastX = x;
    moveBallData.lastY = y;
  }

  const fps = 20;
  const animateBallTo = (x, y, speed = 30) => {
    console.log('animate to', x, y);
    let vecLast = null;
    let dampen = 1.0;
    const id = setInterval(() => {
      setData(prev => {
        const vec = vec_scale(dampen * speed / fps, vec_normalize(vec_sub([x, y], [prev.ball.x, prev.ball.y])));
        const ballNew = {x: prev.ball.x + vec[0], y: prev.ball.y + vec[1]};

        dampen *= 0.99;
        const dist1 = vec_length(vec_sub([x, y], [ballNew.x, ballNew.y])); // distance to target
        const dist2 = vec_length(vec);  // step distance
        const isDone = (
          (vecLast !== null && vec_dot(vec, vecLast) < 0) ||
          dist1 < dist2
        );
        vecLast = vec;

        if (isDone) {
          clearInterval(id);
          ballNew.x = x;
          ballNew.y = y;
        }

        return {
          ...prev,
          ball: ballNew
        }
      });
    }, 1000 / fps);
  }

  const getTeamColor = p => {
    if (p.jersey === 1) {
      // goalie
      return p.team === 'home' ? 'rgb(200,0,200)' : 'rgb(0,150,150)';
    } else {
      // field player
      return p.team === 'home' ? 'blue' : 'red';
    }
  }

  const isOnField = p => {
    return (
      Math.abs(p.x) <= data.field.width/2 &&
      Math.abs(p.y) <= data.field.length/2
    );
  }

  // const controlsProps = () => {
  //   const transformMatrix = new DOMMatrix(
  //     window.getComputedStyle(document.getElementById('root')).transform
  //   );

  //   const result = {
  //     x: transformMatrix.m41,
  //     y: transformMatrix.m42
  //   };
  //   console.log('result', result);
  //   return result;
  // }
  const toggleShadows = () => {
    setShowShadows(prev => !prev);
  }

  const downloadImage = async () => {
    const dataUrl = await convertSVGToPNG(svgRef.current);

    // https://stackoverflow.com/questions/69918382/how-to-download-dataurl-as-png-on-mobile-using-javascript
    // https://jsfiddle.net/jespertheend/fwmu2apo/10/
    const download = document.createElement('a');
    download.download = 'soccerboard';
    download.href = dataUrl;
    download.target = '_blank'
    download.click();
  }

  const shareAsImage = async () => {
    const dataUrl = await convertSVGToPNG(svgRef.current);
    //shareImageDataURL(dataUrl);
    const blob = dataURItoBlob(dataUrl);
    shareImageBlob(blob, 'myimagefilename.png');
  }

  const pixel2svg = (x, y) => {
    if (!svgRef.current) { return {x:0,y:0} };
    let pt = svgRef.current.createSVGPoint();
    pt.x = x;
    pt.y = y;
    const pixel2svg = svgRef.current.getScreenCTM().inverse();
    pt = pt.matrixTransform(pixel2svg);
    if (isIpad) {
      const tmp = (new DOMMatrix(svgContainerRef.current.style.transform)).inverse();
      pt.x *= tmp.a;
      pt.y *= tmp.a;  
    }
    return pt;
  }
  const svg2pixel = (x, y) => {
    if (!svgRef.current) { return {x:0,y:0} };
    const pt = svgRef.current.createSVGPoint();
    pt.x = x;
    pt.y = y;
    return pt.matrixTransform(svgRef.current.getScreenCTM());
  }

  const last = {};
  const drawDown = (e, style) => {
    if (!svgContainerRef.current) return;
    if (!e.isPrimary) return;

    e.preventDefault();
    window.addEventListener('pointermove', drawMove, false);
    window.addEventListener('pointerup', drawUp, false);

    const p = pixel2svg(e.clientX, e.clientY);
    setCurrentStroke([p.x, p.y]);

    last.style = style;
    last.start = { time: new Date(), point: p };

    // https://www.w3schools.com/graphics/svg_stroking.asp
  }
  const drawMove = e => {
    if (!e.isPrimary) return;
    setCurrentStroke(prev => {
      const value = [...prev];
      const p = pixel2svg(e.clientX, e.clientY);

      // add next point to line
      value.push(p.x);
      value.push(p.y);
      return value;
    });
  }
  const drawUp = e => {
    if (!e.isPrimary) return;
    window.removeEventListener('pointermove', drawMove, false);
    window.removeEventListener('pointerup', drawUp, false);

    last.stop = { time: new Date() };

    setCurrentStroke(prev => {
      const keepStroke = prev.length > 3;
      if (keepStroke) {
        const [scribbledIds, hitIds] = isScribble([...prev], data.strokes.map(s => s.points));        console.log('scribble test', hitIds);
        if (scribbledIds.length > 0) {
          const newState = {
            ...data,
            strokes: data.strokes.filter((s,index)=>{ return hitIds.indexOf(index) === -1})
          };
          setData(newState);
        } else {
          const newStroke = {style: last.style, points: [...prev]};
          addStroke(newStroke);
        }
      }
      return null; // reset currentStroke to null
    });
    setDrawMode(false);
    if (!isIpad) {
      setStrokeStyle('Move');
    }
  }
  const testIfDribbleStart = (clientX, clientY) => {
    // down point is near ball or end of pass or dribble stroke
    const nearThreshold = 5; // yards

    // check distance to ball
    const fieldPt = pixel2svg(clientX, clientY);
    const distToBall = vec_length(
      vec_sub([data.ball.x, data.ball.y], [fieldPt.x, fieldPt.y])
    );
    if (distToBall < nearThreshold) {
      return true;
    }

    let result = false;
    data.strokes.forEach(stroke => {
      if (stroke.style === 'Pass' || stroke.style === 'Dribble') {
        const distToStrokeEnd = vec_length(
          vec_sub(
            [stroke.points.at(-2), stroke.points.at(-1)],
            [fieldPt.x, fieldPt.y]
          )
        );
        if (distToStrokeEnd < nearThreshold) {
          result = true;
        }
      }
    });
    return result;
  }
  const choose = (e) => {
    // const isDribble = testIfDribbleStart(e.clientX, e.clientY);
    // drawDown(e, isDribble ? 'Dribble' : 'Run');
    // //drawDown(e, isDribble ? 'Dribble' : strokeStyle);
    // return;

    // if (drawMode || e.pointerType === 'pen' || isDribble) {
    //   drawDown(e, isDribble ? 'Dribble' : strokeStyle);
    // } else {
    //   navDown(e);
    // }

    if (drawMode || e.pointerType === 'pen') {
      drawDown(e, strokeStyle);
    } else {
      navDown(e);
    }
  }
  const sortGoaliesLast = (a,b) => {
    const aMetric = a.jersey === 1 ? 1 : -1;
    const bMetric = b.jersey === 1 ? 1 : -1;
    return (aMetric - bMetric);
  };
  const doSwitchTeams = () => {
    if (nav.dragDistance < 50) {
      console.log('in doSwitchTeams');
      tryVibrate();
      updatePlayerToMove(otherTeam(lastTeamMoved));
      setLastTeamMoved(otherTeam(lastTeamMoved)); // flip to other team
    }

    clearTimeout(nav.longPressTimer);
    nav.longPressTimer = null;
  }
  const otherTeam = team => (team === 'home') ? 'away' : 'home';
  const navLast = {}
  const nav = {}
  const updatePlayerToMove = (team) => {
    console.log('team to move', team);
    let playerToMove = (
      data.players.sort(sortGoaliesLast)
      .filter(x => x.team === team)
      .filter(x => !isOnField(x))
      .at(0)
    );
    if (!playerToMove) {
      playerToMove = (
        data.players.sort(sortGoaliesLast)
        .filter(x => x.team === otherTeam(team))
        .filter(x => !isOnField(x))
        .at(0)
      );
      setLastTeamMoved(otherTeam(team)); // flip to other team
    }
    nav.team = playerToMove?.team;
    nav.jersey = playerToMove?.jersey;
  }
  const navDown = (e) => {
    if (!svgContainerRef.current) return;

    e.preventDefault();

    if (e.isPrimary) {
      // sometimes state can get messed up, like if 'press and hold' / 'context menu' long press is
      // detected.. if pointer event has isPrimary set to true, then reset the 'navLast' state.
      // https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
      Object.keys(navLast).forEach(id => delete navLast[id]);
    }

    if (Object.keys(navLast).length === 0) {
      updatePlayerToMove(lastTeamMoved);
      const field_pt = pixel2svg(e.clientX, e.clientY);
      nav.start = { time: new Date(), x: field_pt.x, y: field_pt.y};
      nav.dragDistance = 0;

      if (nav.longPressTimer) {
        clearTimeout(nav.longPressTimer);
        nav.longPressTimer = null;
      }
      nav.longPressTimer = setTimeout(doSwitchTeams, 1000);

      window.addEventListener('pointermove', navMove, false);
      window.addEventListener('pointerup', navUp, false);
    }

    const svgDownPt = pixel2svg(e.clientX, e.clientY);
    nav.moveTeam = svgDownPt.x < -data.field.width/2 && svgDownPt.x > -data.field.width/2 - 8;
    if (nav.moveTeam) {
      nav.moveTeamName = svgDownPt.y > 0 ? 'home' : 'away';
      movePlayer('down', nav.moveTeamName, null, e.clientX, e.clientY);
    }

    navLast[e.pointerId] = {x: e.clientX, y: e.clientY};
  }
  const navMove = (e) => {
    e.preventDefault();

    if (!(e.pointerId in navLast)) {
      // this seems like a bug.. how can a move happen if down didn't first?
      // anyway for now ignore it...
      //return;

      // if down event was missed... do it here..
      navDown(e);
    }

    const mat = new DOMMatrix(svgContainerRef.current.style.transform);
    switch (Object.keys(navLast).length) {
      case 1: {
        if (nav.moveTeam) {
          movePlayer('move', nav.moveTeamName, null, e.clientX, e.clientY);
          break;
        }

        // handle one-finger navigation
        const fieldBbox = fieldDivRef.current.getBoundingClientRect();
        const imat = mat.inverse();
        const a = new DOMPoint(e.clientX, e.clientY - fieldBbox.top).matrixTransform(imat);
        const b = new DOMPoint(navLast[e.pointerId].x, navLast[e.pointerId].y - fieldBbox.top).matrixTransform(imat);
        const vec = new DOMPoint(a.x - b.x, a.y - b.y);
        mat.translateSelf(vec.x, vec.y);
        // console.log('client', e.clientX, e.clientY);
        // console.log('local', a.x, a.y);
        // console.log('client', navLast[e.pointerId].x, navLast[e.pointerId].y, b.x, b.y);
        // console.log('local', b.x, b.y);
        break;
      }
      case 2: {
        if (nav.longPressTimer) {
          // once a 2nd finger touches, cancel any long press timer
          clearTimeout(nav.longPressTimer);
          nav.longPressTimer = null;
        }

        // handle two-finger navigation
        const imat = mat.inverse();

        const navNow = JSON.parse(JSON.stringify(navLast));
        navNow[e.pointerId] = {x: e.clientX, y: e.clientY};

        const fieldBbox = fieldDivRef.current.getBoundingClientRect();
        const ids = Object.keys(navLast).filter(x=>x!='start'&&x!='stop').map(x=>parseInt(x));
        const old = {};
        const cur = {};
        for(const key in ids) {
          const id = ids[key];
          old[id] = new DOMPoint(navLast[id].x, navLast[id].y - fieldBbox.top).matrixTransform(imat);
          cur[id] = new DOMPoint(navNow[id].x, navNow[id].y - fieldBbox.top).matrixTransform(imat);
        }

        const vecOld = vec_sub([old[ids[0]].x, old[ids[0]].y], [old[ids[1]].x, old[ids[1]].y]);
        const vecNew = vec_sub([cur[ids[0]].x, cur[ids[0]].y], [cur[ids[1]].x, cur[ids[1]].y]);
        const lengthOld = vec_length(vecOld);
        const lengthNow = vec_length(vecNew);
        let scale = lengthNow / lengthOld;

        const oldCenter = new DOMPoint();
        const curCenter = new DOMPoint();
        for(const key in ids) {
          const id = ids[key];
          oldCenter.x += 0.5 * old[id].x;
          oldCenter.y += 0.5 * old[id].y;
          curCenter.x += 0.5 * cur[id].x;
          curCenter.y += 0.5 * cur[id].y;
        }

        // constrain scale
        if (mat.a * scale < scaleMin) {
          scale = scaleMin / mat.a;
        } if (mat.a * scale > scaleMax) {
          scale = scaleMax / mat.a;
        }

        mat.scale3dSelf(scale, curCenter.x, curCenter.y);
        mat.translateSelf(curCenter.x - oldCenter.x, curCenter.y - oldCenter.y);
        break;
      }
    }
    svgContainerRef.current.style.transform = mat.toString();

    updatePixelWidth();

    nav.dragDistance += (
      Math.abs(e.clientX - navLast[e.pointerId].x) +
      Math.abs(e.clientY - navLast[e.pointerId].y)
    );

    navLast[e.pointerId].x = e.clientX;
    navLast[e.pointerId].y = e.clientY;
  }
  const navUp = (e) => {
    e.preventDefault();
    delete navLast[e.pointerId];

    if (Object.keys(navLast).length === 0) {
      window.removeEventListener('pointermove', navMove, false);
      window.removeEventListener('pointerup', navUp, false);

      nav.stop = { time: new Date(), point: {x: e.clientX, y: e.clientY} };

      if (nav.moveTeam) {
        movePlayer('up', nav.moveTeamName, null, e.clientX, e.clientY);
        return;
      }

      const elapsed = nav.stop.time - nav.start.time;
      console.log('elapsed', elapsed);
      if (elapsed < 100 || nav.dragDistance < 50) {
        if (nav.team && nav.jersey) {
          // if a player not on the field still exists..
          const newState = {...data};
          newState.players = newState.players.map(item => {
            if (item.team === nav.team && item.jersey === nav.jersey) {
              return {
                ...item,
                x: nav.start.x,
                y: nav.start.y,
              };
            } else {
              return item;
            }
          });
          setData(newState);
        }
      }
    }

    if (nav.longPressTimer) {
      clearTimeout(nav.longPressTimer);
      nav.longPressTimer = null;
    }
  }

  const navContextMenu = e => {
    // prevent context menu from appearing, so long press can toggle which team to add
    e.preventDefault();
  }

  const navWheel = (e) => {
    e.stopPropagation();

    const fieldBbox = fieldDivRef.current.getBoundingClientRect();
    let scale = Math.pow(e.deltaY > 0 ? 0.99 : 1.005, Math.abs(e.deltaY));
    const mat = new DOMMatrix(svgContainerRef.current.style.transform);
    const imat = mat.inverse();
    const pos = new DOMPoint(e.clientX, e.clientY - fieldBbox.top).matrixTransform(imat);
    //const fieldPt = pixel2svg(e.clientX, e.clientY);

    // constrain scale
    if (mat.a * scale < scaleMin) {
      scale = scaleMin / mat.a;
    } if (mat.a * scale > scaleMax) {
      scale = scaleMax / mat.a;
    }
    mat.scale3dSelf(scale, pos.x, pos.y);
    svgContainerRef.current.style.transform = mat.toString();
    updatePixelWidth();
  }

  const clearStrokes = () => {
    const newData = createNewBoard();
    setData(newData);
    // setData(prev => ({...prev, strokes: []}));
  }
  const addStroke = (stroke) => {
    //console.log('in addStroke', data.strokes.length);

    const newState = {
      ...data,
      strokes: [...data.strokes, stroke]
    };
    setData(newState);
  }
  const toggleDraw = () => {
    setDrawMode(prev => !prev);
  }

  const polylineDataFromStroke = (pts, style, pixelWidth) => {
    if (style === 'Run' || style === 'Pass') {
      let result = '';
      for(let i=0;i<pts.length;i+=2) {
        result += `${pts[i]}, ${pts[i+1]} `;
      }
      return result;  
    } else if (style === 'Dribble') {
      let result = '';
      for(let i=0;i<pts.length-2;i+=2) {
        const perp = vec_perpendicular(vec_normalize(vec_sub([pts[i+2], pts[i+3]], [pts[i], pts[i+1]])));
        const s = Math.sin(i);
        const p = vec_add([pts[i], pts[i+1]], [s*perp[0], s*perp[1]]);
        result += `${p[0]}, ${p[1]} `;
      }
      return result;
    }
  }

  const createStroke = (stroke, style, pixelWidth) => {
    const strokeColor = isIpad ? "purple" : "purple";
    return (
      <g key={`${stroke[0]}_${stroke[1]}_${stroke.at(-2)}_${stroke.at(-1)}`}>
        <path
          d={pathDataFromStroke(stroke, style, pixelWidth)}
          stroke={strokeColor}
          strokeWidth={pixelWidth * 4}
          strokeDasharray={style === 'Run' ? `${pixelWidth * 10} ${pixelWidth * 10}` : ''}
          fill="transparent"
        />
        <polyline
          className="stroke"
          points={arrowDataFromStroke(stroke, style, pixelWidth)}
          stroke={strokeColor}
          strokeWidth={pixelWidth * 4}
          fill="transparent"
        />
      </g>
    );
  }

  const createStroke2 = (stroke, style, pixelWidth) => {
    const strokeColor = isIpad ? "purple" : "purple";
    const dist = 1;
    const pts = calculateEvenPoints(stroke, dist);

    let stroke2 = [];
    pts.forEach(p => {
      stroke2.push(p[0]);
      stroke2.push(p[1]);
    });

    return (
      <g className="stroke" key={`${stroke[0]}_${stroke[1]}_${stroke.at(-2)}_${stroke.at(-1)}`}>
        <path
          d={pathDataFromStroke(stroke2, style, pixelWidth)}
          stroke={strokeColor}
          strokeWidth={pixelWidth * 4}
          strokeDasharray={style === 'Run' ? `${pixelWidth * 10} ${pixelWidth * 10}` : ''}
          fill="transparent"
        />
        {style !== 'Line' && (
          <polyline
            className="stroke"
            points={arrowDataFromStroke(stroke2, style, pixelWidth)}
            stroke={strokeColor}
            strokeWidth={pixelWidth * 4}
            fill="transparent"
          />
        )}
      </g>
    );
  }

  const createDebugStroke = (stroke, style, pixelWidth) => {
    const dist = 1;
    const pts = calculateEvenPoints(stroke, dist);

    return (
      <g key={`debug_${stroke[0]}_${stroke[1]}_${stroke.at(-2)}_${stroke.at(-1)}`}>
        <polyline
          className="stroke"
          points={pts.map(p => p.join(',')).join(',')}
          // points={stroke.join(',')}
          stroke="white"
          strokeWidth={pixelWidth}
          fill="transparent"
        />
      </g>
    );
  }

  const undoLastStroke = () => {
    if (data.strokes.length === 0) return;

    setData(prev => {
      const newState = {
        ...prev,
        strokes: [...prev.strokes],
      }
      newState.strokes.pop();
      return newState;
    });
  }

  const guiStroke = (style) => {
    const w = 300;
    const h = 200;
    return (
      <div style={{position: 'absolute', width: '50px', height: '20px', left: '13px', top: '24px'}}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid meet"
          fill="white"
          viewBox="0 -5 20 10"
          id="guiStroke"
        >
          {createStroke2([0, 0, 20, 0], style, .25)}
        </svg>
      </div>
    );
  }

  const formations = {
    'clear': [{"team":"home","jersey":1,"x":0,"y":50.60348892211914},{"team":"home","jersey":2,"x":-30,"y":62},{"team":"home","jersey":3,"x":-25,"y":62},{"team":"home","jersey":4,"x":-20,"y":62},{"team":"home","jersey":5,"x":-15,"y":62},{"team":"home","jersey":6,"x":-10,"y":62},{"team":"home","jersey":7,"x":-5,"y":62},{"team":"home","jersey":8,"x":0,"y":62},{"team":"home","jersey":9,"x":5,"y":62},{"team":"home","jersey":10,"x":10,"y":62},{"team":"home","jersey":11,"x":15,"y":62}],
    '4-3-3': [{"team":"home","jersey":8,"x":-25.796955108642578,"y":28.357540130615234},{"team":"home","jersey":2,"x":-27.33013153076172,"y":1.4548341035842896},{"team":"home","jersey":4,"x":26.602720260620117,"y":0.8313329815864563},{"team":"home","jersey":5,"x":-11.1884765625,"y":12.566279411315918},{"team":"home","jersey":6,"x":7.678258895874023,"y":11.442509651184082},{"team":"home","jersey":7,"x":0.3444657325744629,"y":21.37861442565918},{"team":"home","jersey":3,"x":-2.384185791015625e-7,"y":1.2470035552978516},{"team":"home","jersey":9,"x":-10.774506568908691,"y":35.92790985107422},{"team":"home","jersey":10,"x":8.861126899719238,"y":35.3956184387207},{"team":"home","jersey":11,"x":26.604175567626953,"y":27.470388412475586},{"team":"home","jersey":1,"x":0,"y":50.60348892211914}],
    '4-4-2': [{"team":"home","jersey":4,"x":7.450980186462402,"y":10.220355987548828},{"team":"home","jersey":5,"x":6.479163609445095,"y":22.038433074951172},{"team":"home","jersey":6,"x":24.74021816253662,"y":18.969895362854004},{"team":"home","jersey":7,"x":-7.762673616409302,"y":21.771394729614258},{"team":"home","jersey":8,"x":-24.199128955602646,"y":33.970008850097656},{"team":"home","jersey":9,"x":-8.394651412963867,"y":35.3586483001709},{"team":"home","jersey":10,"x":6.727985382080078,"y":34.88277244567871},{"team":"home","jersey":11,"x":25.994171142578125,"y":32.4859619140625},{"team":"home","jersey":2,"x":-22.438456535339355,"y":19.69162952899933},{"team":"home","jersey":3,"x":-9.460736960172653,"y":9.64732551574707},{"team":"home","jersey":1,"x":0,"y":50.60348892211914}],
    '3-3-4': [{"team":"home","jersey":4,"x":24.004804611206055,"y":1.6626647114753723},{"team":"home","jersey":5,"x":-20.12532329559326,"y":15.787696838378906},{"team":"home","jersey":11,"x":3.5346319675445557,"y":1.9068400859832764},{"team":"home","jersey":8,"x":-20.497194290161133,"y":27.83795928955078},{"team":"home","jersey":7,"x":-0.48686598241329193,"y":15.455354690551758},{"team":"home","jersey":6,"x":20.148283004760742,"y":14.871766090393066},{"team":"home","jersey":10,"x":21.019399642944336,"y":28.01752471923828},{"team":"home","jersey":9,"x":-0.7984877824783325,"y":28.134145736694336},{"team":"home","jersey":2,"x":-24.83612823486328,"y":1.8705047369003296},{"team":"home","jersey":3,"x":-3.637087404727936,"y":1.662664771080017},{"team":"home","jersey":1,"x":0,"y":50.60348892211914}],
  }
  const updateFormation = (e, team, formation) => {
    e.stopPropagation();

    if (team === 'home') {
      const positions = formations[formation];
      setData(prev => {
        const newPlayers = prev.players.map(p => {
          const index = positions.findIndex(x => x.jersey === p.jersey);
          if (p.team === team && index >= 0) {
            return {
              ...p,
              x: positions[index].x,
              y: positions[index].y,
            };
          } else {
            return p;
          }
        });
        return {
          ...prev,
          players: newPlayers,
        }
      });
    } else if (team === 'away') {
      const positions = formations[formation];
      setData(prev => {
        const newPlayers = prev.players.map(p => {
          const index = positions.findIndex(x => x.jersey === p.jersey);
          if (p.team === team && index >= 0) {
            return {
              ...p,
              x: positions[index].x,
              y: -positions[index].y, // negate 'y' so player is positioned on away side of field
            };
          } else {
            return p;
          }
        });
        return {
          ...prev,
          players: newPlayers,
        }
      });
    }
  }

  const playerIcon = (team) => {
    return (
      <div style={{marginLeft: '6px', width: '14px', height: '14px'}}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid meet"
          fill="white"
          viewBox="-1 -1 3 3"
          id="playerIcon"
        >
          <Player team={team} x="0" y="0" showNumbers={false} showNames={false} offsetTouchMove={false} color={getTeamColor({team,jersey:2})} />
        </svg>
      </div>
    );
  }

  const updateText = (textEditIndex, updatedText) => {
    setData(prev => {
      const newText = prev.text.map((item, index) => {
        if (index === textEditIndex) {
          return {
            ...item,
            text: updatedText
          }
        } else {
          return item;
        }
      });
      return {
        ...prev,
        text: newText,
      }
    });
  }

  const onClickAddTextBox = () => {
    setData(state => {
      state.text.push(
        {
          text: 'Click to edit',
          x: 0,
          y: 0,
          w: 30,
          angle: 10,
        }
      );
      return state;
    });

    setAddMenuEl(null);
  }
  const onClickAddTimestamp = () => {
    // https://stackoverflow.com/questions/14638018/current-time-formatting-with-javascript
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var d = new Date();
    var date = d.getDate();
    var month = months[d.getMonth()];
    var year = d.getFullYear();

    setData(state => {
      state.text.push(
        {
          text: `${month} ${date}, ${year}`,
          x: 0,
          y: 0,
          w: 30,
          angle: 10,
        }
      );
      return state;
    });

    setAddMenuEl(null);
  }

  const updateSettings = (newSettings) => {
    setSettings({...newSettings, vdebug: setDebugMessage});
    setShowSettings(false);

    localStorage.setItem('settings', JSON.stringify(newSettings));
  }

  const zoomCenter = (scale) => {
    const mat = new DOMMatrix(svgContainerRef.current.style.transform);
    const imat = mat.inverse();

    //const bbox = svgContainerRef.current.getBoundingClientRect();
    const bbox = fieldDivRef.current.getBoundingClientRect();
    console.log('bbox', bbox);
    const pos = new DOMPoint(bbox.width/2, bbox.height/2).matrixTransform(imat);
    // 412 x 800
    //const pos = new DOMPoint(412/2, 800/2).matrixTransform(imat);

    // constrain scale
    if (mat.a * scale < scaleMin) {
      scale = scaleMin / mat.a;
    } if (mat.a * scale > scaleMax) {
      scale = scaleMax / mat.a;
    }
    mat.scale3dSelf(scale, pos.x, pos.y);
    svgContainerRef.current.style.transform = mat.toString();
    updatePixelWidth();
  }
  const scaleK = 1.2;
  const onClickZoomIn = () => {
    zoomCenter(scaleK);
  }
  const onClickZoomOut = () => {
    zoomCenter(1.0/scaleK);
  }

  const onClickCreateBoard = () => {
    tryVibrate();
    console.log('onCreateBoard called');
    const newData = createNewBoard();
    const item = localFileManager.create(newData);
    switchToBoard(item);
  }
  const onClickBoardTile = (e) => {
    tryVibrate(100);
    const id = e.currentTarget.dataset.id;
    console.log('onClickBoardTile', id, e);
    const board = localFileManager.read(id);
    switchToBoard(board);
  }
  const onClickLongBoardTile = (e) => {
    tryVibrate();
    const id = e.currentTarget.dataset.id;
    console.log('onLongClickBoardTile', id, e);

    localFileManager.deleteFile(id);

    // load next reasonable board or show nothing if no boards left
    const boards = localFileManager.list();
    switchToBoard(boards.length > 0 ? boards[0] : null);
  }

  const onClickGetNews = () => {
    const getNewsUrl = 'https://forms.gle/No7pMTsU1SQxRMyi7';
    window.open(getNewsUrl, '_blank')
  }

  // workaround.. when zoom in on phone, settings dialog shows up in weird place,
  // apparently beacuse of transform setting on <svg> element (?).. unclear why,
  // but hiding div/svg "fixes" the issue.
  // style={{display:(showSettings?'none':'')}}
  //console.log('data', data);
  return (
    <div className="top-container">
      <div className="header">
        <FileManager
          files={Files.files}
          currentBoardId={currentBoardId}
          onClickCreateBoard={onClickCreateBoard}
          onClickBoardTile={onClickBoardTile}
          onClickLongBoardTile={onClickLongBoardTile}
        />
      </div>
      <div className="footer-body">
        <div className="body-footer">
          <div style={{width: '100%', position: 'relative'}}>
            {/* <div className="gui-buttons">
              <button onClick={clearStrokes}>Clear</button>
              <button onClick={toggleShadows}>Shadows</button>
              <button onClick={downloadImage}><span className="download-icon"><DownloadIcon /></span> PNG</button>
              <button onClick={shareAsImage}>Share PNG</button>
              <button onClick={toggleShowNumbers}>Numbers</button>
            </div> */}
            {/* <div className="gui-buttons">
              <ToggleButtonGroup
                orientation="horizontal"
                value={strokeStyle}
                exclusive
                onChange={(e, newValue) => { setDrawMode(true); setStrokeStyle(newValue || strokeStyle); }}
                aria-label="Draw style"
              >
                <ToggleButton value="Line">Line{guiStroke('Line')}</ToggleButton>
                <ToggleButton value="Run">Run{guiStroke('Run')}</ToggleButton>
                <ToggleButton value="Pass">Pass{guiStroke('Pass')}</ToggleButton>
                <ToggleButton value="Dribble">Dribble{guiStroke('Dribble')}</ToggleButton>
              </ToggleButtonGroup>
            </div> */}

            <div className="gui-buttons">
              <Select
                value={strokeStyle}
                onChange={(e, newValue) => { setDrawMode(e.target.value != 'Move'); setStrokeStyle(e.target.value); }}
              >
                <MenuItem value="Move">Move</MenuItem>
                <MenuItem value="Line">Line{guiStroke('Line')}</MenuItem>
                <MenuItem value="Run">Run{guiStroke('Run')}</MenuItem>
                <MenuItem value="Pass">Pass{guiStroke('Pass')}</MenuItem>
                <MenuItem value="Dribble">Dribble{guiStroke('Dribble')}</MenuItem>
              </Select>
              <Button onClick={(e) => setAddMenuEl(e.currentTarget)}><AddCircleIcon/></Button>
              <Button
                onClick={() => { setLastTeamMoved(otherTeam(lastTeamMoved)); }}
              >
                Next
                {playerIcon(lastTeamMoved)}
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={addMenuEl}
                open={addMenuEl !== null}
                onClose={() => setAddMenuEl(null)}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem onClick={onClickAddTextBox}>Text Box</MenuItem>
                <MenuItem onClick={onClickAddTimestamp}>Timestamp</MenuItem>
                <MenuItem onClick={() => setAddMenuEl(null)}>Cone</MenuItem>
                <MenuItem onClick={() => setAddMenuEl(null)}>Image</MenuItem>
                <MenuItem onClick={() => setAddMenuEl(null)}>Video</MenuItem>
              </Menu>
            </div>
            <div className="gui-buttons">
              {/* <button onClick={() => setGuiLocation(last => last === 'bottom' ? 'top' : 'bottom')}>GUI</button>
              <button onClick={undoLastStroke} disabled={data.strokes.length === 0}>Undo Stroke</button> */}

              <div style={{position: 'absolute', left: '0px'}}>
                <IconButton onClick={() => setShowSettings(true)}><SettingsIcon/></IconButton>
              </div>
              <IconButton onClick={undo} disabled={!canUndo}><UndoIcon/></IconButton>
              <IconButton onClick={redo} disabled={!canRedo}><RedoIcon/></IconButton>
            </div>

            <div className="get-updates">
              <Button onClick={onClickGetNews}>Get News</Button>
            </div>

          </div>
        </div>

        {data && (
        <div ref={fieldDivRef} className="field-view">
          <div className="sportboard">
            <div
              ref={svgContainerRef}
              className="field-container"
              onPointerDown={choose}
              onWheel={navWheel}
              onContextMenu={navContextMenu}
              style={{display:(showSettings?'none':'')}}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                ref={svgRef}
                preserveAspectRatio="xMidYMid meet"
                fill="currentColor"
                viewBox={`${-data.field.width/2 - 10} ${-data.field.length/2 - 10} ${data.field.width + 2*10} ${data.field.length + 2*10}`}
                style={{background: '#eee'}}
              >
                <defs>
                  <clipPath id="fieldClipPath">
                    <rect x={-data.field.width/2} y={-data.field.length/2} width={data.field.width} height={data.field.length} />
                  </clipPath>
                  <clipPath id="outsidePenaltyAreas">
                    <rect x={-data.field.width/2} y={-data.field.length/2+18} width={data.field.width} height={data.field.length-18*2} />
                  </clipPath>
                </defs>
                <SettingsProvider settings={settings}>
                  <SvgProvider pixelData={pixelData} pixel2svg={pixel2svg} svg2pixel={svg2pixel}>
                            <Field width={data.field.width} length={data.field.length} />
                            {showShadows && (
                              <g opacity={0.5} clipPath="url(#fieldClipPath)">
                                {data.players.filter(p=>p.team==='away').filter(p=>isOnField(p)).map(p => <Shadow ball={data.ball} player={p} />)}
                              </g>
                            )}
                            {[...data.players].reverse().map(p => (
                              <Player
                                key={`${p.team}_${p.jersey}`}
                                team={p.team}
                                jersey={p.jersey}
                                name={roster[p.jersey]}
                                x={p.x}
                                y={p.y}
                                offsetTouchMove={settings.offsetTouchMove}
                                showNumbers={settings.showPlayerNumbers}
                                showNames={settings.showPlayerNames}
                                color={getTeamColor(p)}
                                moveFunc={movePlayer}
                              />
                            ))}
                            <Ball x={data.ball.x} y={data.ball.y} moveFunc={moveBall}/>
                            {/*
                              run = dashed white
                              pass = solid red
                              dribble = squiggle red
                            */}
                            {currentStroke && createStroke2(currentStroke, strokeStyle, pixelData.pixelWidth)}
                            {/* {currentStroke && createStroke2(currentStroke, last.style, pixelData.pixelWidth)} */}
                            {/* {currentStroke && createDebugStroke(currentStroke, strokeStyle, pixelData.pixelWidth)} */}
                            {/* {data && data.strokes.map(s => createStroke(s.points, s.style, pixelData.pixelWidth))} */}
                            {data && data.strokes.map(s => createStroke2(s.points, s.style, pixelData.pixelWidth))}
                            {/* {data && data.strokes.map(s => createDebugStroke(s.points, s.style, pixelData.pixelWidth))} */}
                            {drawMode && (
                              <Field width={data.field.width} length={data.field.length} rectOnly={true} fill="rgba(255,255,255,0.01)" />
                            )}
                            {data.players.filter(p => isOnField(p) && p.jersey !== 1).length === 0 && (
                              <g>
                                <text x={0} y={20} textAnchor="middle" fontSize={3} fill="rgba(255,255,255,0.5)">Tap to add players</text>
                                <text transform={`translate(${-data.field.width/2-1},50) rotate(-90,0,0)`} x={0} y={0} textAnchor="left" fontSize={3} fill="rgba(255,255,255,0.5)">Drag here moves home team</text>
                                <text transform={`translate(${-data.field.width/2-1},-10) rotate(-90,0,0)`} x={0} y={0} textAnchor="left" fontSize={3} fill="rgba(255,255,255,0.5)">Drag here moves away team</text>
                              </g>
                            )}
                            {data.text.map((item, index) => (
                              <TextBox
                                key={JSON.stringify(item)}
                                text={item.text}
                                x={item.x}
                                y={item.y}
                                w={item.w}
                                angle={item.angle}
                                onClick={e => { e.preventDefault(); e.stopPropagation(); setTextEditIndex(index);}}
                                index={index}
                                moveFunc={moveText}
                              />
                            ))}
                            {circleEffect && (
                              <CircleFader x={circleEffect.x} y={circleEffect.y} onDone={() => setCircleEffect(null)} />
                            )}
                  </SvgProvider>
                </SettingsProvider>
              </svg>
            </div>
          </div>

          <div id="zoom" style={{position:'absolute', right:'0px', bottom:'0px', display: 'flex', flexFlow: 'column'}}>
            <div className="zoom-button">
              <Button variant="contained" onClick={onClickZoomIn}>+</Button>
            </div>
            <div className="zoom-button">
              <Button variant="contained" onClick={onClickZoomOut}>-</Button>
            </div>
          </div>
        </div>
        )}

      </div>

      {/* <div className="gui-right-bottom">
        <div className="gui-buttons">
          <div><Button variant="outlined" onClick={(e) => updateFormation(e, 'home', '4-3-3')}>4-3-3</Button></div>
          <div><Button variant="outlined" onClick={(e) => updateFormation(e, 'home', '4-4-2')}>4-4-2</Button></div>
          <div><Button variant="outlined" onClick={(e) => updateFormation(e, 'home', '3-3-4')}>3-3-4</Button></div>
          <div><Button variant="outlined" onClick={(e) => updateFormation(e, 'home', 'clear')}>Clear</Button></div>
        </div>
      </div>
      <div className="gui-right-top">
        <div className="gui-buttons">
          <div><Button variant="outlined" onClick={(e) => updateFormation(e, 'away', '4-3-3')}>4-3-3</Button></div>
          <div><Button variant="outlined" onClick={(e) => updateFormation(e, 'away', '4-4-2')}>4-4-2</Button></div>
          <div><Button variant="outlined" onClick={(e) => updateFormation(e, 'away', '3-3-4')}>3-3-4</Button></div>
          <div><Button variant="outlined" onClick={(e) => updateFormation(e, 'away', 'clear')}>Clear</Button></div>
        </div>
      </div> */}

      {textEditIndex !== null && (
        <TextBoxInput
          text={data.text[textEditIndex].text}
          onCancel={() => setTextEditIndex(null)}
          onOk={text => { updateText(textEditIndex, text); setTextEditIndex(null); } }
        />
      )}

      {/* <NewsSignupForm
        text=""
        onCancel={() => {} }
        onOk={text => { } }
      /> */}

      {showSettings && (
        <SettingsView
          settings={settings}
          handleClose={() => setShowSettings(false)}
          handleOkay={updateSettings}
        />
      )}

      {/* <VisualDebug message={debugMessage}/> */}
    </div>
  );
}

export default SoccerBoard;
